<template>
    <div class="chart_main">
        <div ref="chart_main" style="width: 100%;height: 100%"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { TooltipComponent, LegendComponent,TitleComponent,ToolboxComponent } from 'echarts/components'
import { PieChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import request from "@/utils/request"

echarts.use(
    [TooltipComponent, LegendComponent, PieChart, CanvasRenderer,TitleComponent,ToolboxComponent]
)

export default {
    name: 'today_orders',
    props:[
        "data"
    ],
    data() {
        return {
            chart:null,
            option: {
                legend: {
                    // data: ['当前']
                },
                color: ['#6cdefb'],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            left: '0%',
                            right: '0%',
                            bottom: '0%',
                            top:'10%',
                            containLabel: true
                        },
                        calculable: true,
                        xAxis: [
                            {
                                type: 'category',
                                axisTick: {show: false},
                                data: ['待审核', '已审核', '已打卡', '已登记', '已安检','已入场']
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        series: [
                            // {   name:'累计',
                            //     type: 'bar',
                            //     barGap: 0,
                            //     data: [320, 332, 301, 334, 390,360,320],
                            //     itemStyle:{
                            //         normal:{
                            //             label:{
                            //                 show:true,
                            //                 position:'top',
                            //                 textStyle:{
                            //                     color:'blue'
                            //                 }
                            //             }
                            //         }
                            //     }
                            // },
                            {   
                                // name:'当前',
                                type: 'bar',
                                data: [220, 182, 191, 234, 290,320,220],
                                itemStyle:{
                                    normal:{
                                        label:{
                                            show:true,
                                            position:'top',
                                            textStyle:{
                                                color:'red'
                                            }
                                        }
                                    }
                                }
                            },
                        ]
            }
        }
    },
    methods: {
        init(){
            request.get('index/status_count').then(res=>{
                if(res.code==200){
                    this.option.xAxis.data=res.data.xData
                    // this.option.series[0].data=res.data.total
                    this.option.series[0].data=res.data.curr
                    this.chart = echarts.init(this.$refs["chart_main"]);
                    this.chart.setOption(this.option);
                }
            })
        },
    },
    created() {

    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
   
</style>
